export function intelligenceSuitePageProps() {
  const reports = [
    {
      reportIdentifier: 'sentiment_workbook',
      type: 'tableau_workbook',
      workbookTabs: [
        {
          tableauTabUri: 'Sentiment',
          tableauWorksheetName: 'Sentiment',
          title: 'Sentiment',
          urlFragment: 'sentiment',
        },
        {
          tableauTabUri: 'Compare',
          tableauWorksheetName: 'Compare',
          title: 'Compare',
          urlFragment: 'compare',
        },
      ],
    },
  ];
  const DEFAULT_TAB = reports[0].workbookTabs[0].urlFragment;
  const PAGE_URL = '/product-sentiment';
  const PAGE_TITLE = 'Product Sentiment';

  const navigationProps = {
    crumbs: [
      {
        label: 'Analytics',
        href: `/`,
      },
      {
        label: PAGE_TITLE,
        href: PAGE_URL,
      },
    ],
    activePrimary: 'Analytics',
    activeSecondary: PAGE_TITLE,
  };

  return {
    defaultTab: DEFAULT_TAB,
    navigationProps,
    pageUrl: PAGE_URL,
    reports,
  };
}
